export function parseTableToMarkdown(data) {
  if (data.content && data.content.length > 0) {
    const rows = data.content.map((columns) => {
      // Apply formatting for each column
      const formattedColumns = columns.map((cell) => {
        let text = cell;

        // Replace <b> with * for bold text
        text = text.replace(/<b>(.*?)<\/b>/g, '*$1*');

        // Replace <i> with _ for italic text
        text = text.replace(/<i>(.*?)<\/i>/g, '_$1_');

        // Replace <u> with + for underline text, accounting for attributes like class
        text = text.replace(/<u[^>]*>(.*?)<\/u>/g, '+$1+');

        // Replace <code> with {{}} for inline code
        text = text.replace(/<code.*?>(.*?)<\/code>/g, '{{$1}}');

        // Replace <mark> with {color:#0747a6} for highlighted text
        text = text.replace(/<mark.*?>(.*?)<\/mark>/g, '{color:#0747a6}$1{color}');

        // Replace <a href> with [link_text|url|smart-link]
        text = text.replace(/<a href="(.*?)">(.*?)<\/a>/g, '[$2|$1|smart-link]');

        // Replace <br> with newline character \n
        text = text.replace(/<br\s*\/?>/g, '\n');

        // Replace &nbsp; with a regular space
        text = text.replace(/&nbsp;/g, ' ');

        return text;
      });

      // Join columns for this row
      return '|' + formattedColumns.join('|') + '|';
    });

    // Join rows with line breaks
    return rows.join('\n');
  }
}
